import { render, staticRenderFns } from "./RequestMigration.vue?vue&type=template&id=7634a13d"
import script from "./RequestMigration.vue?vue&type=script&lang=js"
export * from "./RequestMigration.vue?vue&type=script&lang=js"
import style0 from "./RequestMigration.vue?vue&type=style&index=0&id=7634a13d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports